import moment from "moment";

// Función para obtener la fecha actual en UTC
export const getCurrentUTCDate = () => {
    return moment.utc().subtract(5, 'hours').toDate();
}